import { useAppState } from './context/State';
import Loader from './components/Loader';
import ErrorBoundary from './components/common/ErrorBoundary';
import LoadingSpinner from './components/common/LoadingSpinner';
import { HOME_PATHS } from './constants';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import FilteredVideoCarousel from './components/FilteredVideoCarousel';
import BrandPage from './components/BrandPage';
import './App.scss';
import ScrollToTop from './hooks/scrollToTop';
import * as Sentry from '@sentry/browser';
import { useEffect, useState } from 'react';

Sentry.init({
  dsn: 'https://4db026b9d53aec750f8960410faa9ead@o4504488188903424.ingest.sentry.io/4505705728507904',
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['localhost', 'https:yourserver.io/api/'],
    }),
    new Sentry.Replay(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

function App() {
  const state = useAppState();
  const { error, ready, loading } = state;
  const [scrollPosition, setScrollPosition] = useState(0);
  
  const handleScroll = () => {
    const position = window.scrollY;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    const header = document.getElementsByClassName('header-main-nav')[0];
    if (scrollPosition === 0) {
      header?.classList.remove('scrolled');
    } else {
      header?.classList.add('scrolled');
    }
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrollPosition]);

  if (error) {
    return (
      <div className="appContainer">
        <div className="error-container">
          <h2>Something went wrong</h2>
          <p>We're having trouble loading the content. Please try again later.</p>
          <button onClick={() => window.location.reload()} className="retry-button">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  if (loading || !ready || !state || !state.adData) {
    return (
      <div className="appContainer">
        <LoadingSpinner message="Loading ad gallery..." />
      </div>
    );
  }
  const home = HOME_PATHS;

  return (
    <ErrorBoundary>
      <div className="appContainer">
        <ScrollToTop />
        <Routes>
          {home.map((path) => (
            <Route key={path} path={path} element={<FilteredVideoCarousel />} />
          ))}
          {home.map((path) => (
            <Route key={`${path}display/:brand`} path={`${path}display/:brand`} element={<BrandPage />} />
          ))}
          {home.map((path) => (
            <Route key={`${path}display/:brand/`} path={`${path}display/:brand/`} element={<BrandPage />} />
          ))}
          {home.map((path) => (
            <Route key={`${path}video/:brand`} path={`${path}video/:brand`} element={<BrandPage />} />
          ))}
          {home.map((path) => (
            <Route key={`${path}video/:brand/`} path={`${path}video/:brand/`} element={<BrandPage />} />
          ))}
          {home.map((path) => (
            <Route key={`${path}video`} path={`${path}video`} element={<Navigate to={path} />} />
          ))}
          {home.map((path) => (
            <Route key={`${path}video/`} path={`${path}video/`} element={<Navigate to={path} />} />
          ))}
          {home.map((path) => (
            <Route key={`${path}display`} path={`${path}display`} element={<Navigate to={path} />} />
          ))}
          {home.map((path) => (
            <Route key={`${path}display/`} path={`${path}display/`} element={<Navigate to={path} />} />
          ))}
        </Routes>
      </div>
    </ErrorBoundary>
  );
}

export default App;
